import authService from "../../../auth/AuthService";
import {addEditDPActionTypes} from "../constants/AddEditActionConstants";

const setDPForm = ({ name, value, change_obj }) => ({
    type: addEditDPActionTypes.SETTING_DP_FORM_OBJECT_VALUE,
    payload: { name, value, change_obj },
});

const updateContact = ({ name, value, change_obj }) => ({
    type: addEditDPActionTypes.UPDATE_DP_CONTACT,
    payload: {name, value, change_obj},
});

const validateDataProviderForm = ({ providerObject, authToken }) => ({
    type: addEditDPActionTypes.VALIDATE_DATA_PROVIDER_FORM,
    payload: { providerObject, authToken }
});

const updatedDP = () => ({
    type: addEditDPActionTypes.UPDATED_DP_REFRESH
});

export function setDPFormValues({ name, value, change_obj }) {
    return (dispatch) => {
        dispatch(setDPForm({ name, value, change_obj }));
    }
}

export function updateContactInfo({ name, value, change_obj }) {
    return (dispatch) => {
        dispatch(updateContact({ name, value, change_obj }))
    }
}

export function updatedDPRefresh() {
    return (dispatch) => {
        dispatch(updatedDP())
    }
}

export function validateDataProvider(providerObject) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(validateDataProviderForm({providerObject, authToken}))
    }
}
